export function documentUrl(document) {
  return `https://backoffice-api.element.in/customers/${document.customerId}/documents/${document.id}/content`
}

export function shadowFlowDocumentUrl(document) {
  return `https://api.element.in/customers/${document.customerId}/shadowFlowDocuments/${document.id}/content`
}
